import React from 'react';

import { ExtranetRoomStatus } from 'app/typings/core/extranet/hotel/rooms';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useReadOnlyRowConfig } from '../../../../../hooks/useReadOnlyRowConfig';
import type { RoomOpeningInventory } from '../../../../../utils/rooms';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { StatusCell } from '../../../../Table/Cells/StatusCell/StatusCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';
import { getStatusInfo } from '../../../inventoryStatusUtils';

const RoomStatusRowComponent: React.FC<{ roomId: number }> = ({ roomId }) => {
  const { inventoryRooms, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Rooms
  );

  if (!inventoryRooms) {
    return null;
  }

  return (
    <TableRow isHeader>
      <LabelCell label="Status" />
      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, `${roomId}`];

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: RoomOpeningInventory) => {
              const statusInfo = values ? getStatusInfo(values) : undefined;

              return (
                <StatusCell
                  status={
                    values?.inventoryStatus ?? ExtranetRoomStatus.PUBLISHED
                  }
                  tooltipText={statusInfo?.label}
                  name={fieldName}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const RoomStatusRow = React.memo(RoomStatusRowComponent);
